<template>
  <ValidationProvider
    v-slot="{ errors }"
    :vid="vid"
    :mode="mode"
    :name="String(_uid)"
    :rules="rules"
  >
    <ckeditor
      v-model="innerValue"
      :class="`${customClass} ${requiredClassByRules()}`"
      :data-cy-validation-result="errors.length ? rulesToString() : false"
      :error-messages="errors"
      :editor="editor"
      :config="editorConfig"
      v-bind="$attrs"
      v-on="$listeners"
    ></ckeditor>
  </ValidationProvider>
</template>

<script>
import { validationMixin } from '../mixins/validation'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  mixins: [validationMixin],
  props: {
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
    },
    customClass: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'aggressive',
    },
    vid: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    innerValue: '',
    editor: ClassicEditor,
    editorConfig: {
      // The configuration of the editor.
    },
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>

<style>
.ck-editor__editable {
  min-height: 200px;
}
</style>
